export const signin = (credentails) => {
  return (dispatch, getState, { getFirebase }) => {
    const firebase = getFirebase();
    firebase
      .auth()
      .signInWithEmailAndPassword(credentails.email, credentails.password)
      .then(() => {
        dispatch({ type: "LOGIN_SUCCESS" });
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: "LOGIN_ERROR" }, err);
      });
  };
};
export const signOut = () => {
  return (dispatch, getState, { getFirebase }) => {
    const firebase = getFirebase();
    firebase
      .auth()
      .signOut()
      .then(() => {
        dispatch({ type: "SIGNOUT_SUCCESS" });
      })
      .catch((err) => {
        return err;
      });
  };
};
export const signUp = (newUser) => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();
    const firebase = getFirebase();
    firebase
      .auth()
      .createUserWithEmailAndPassword(newUser.email, newUser.password)
      .then((response) => {
        return firestore
          .collection("users")
          .doc(response.user.uid)
          .set({
            firstName: newUser.firstName,
            lastName: newUser.lastName,
            initials:
              newUser.firstName[0].toUpperCase() +
              newUser.lastName[0].toUpperCase(),
          });
      })
      .then(() => {
        dispatch({ type: "SIGNUP_SUCCESS" });
      })

      .catch(function (error) {
        // Handle Errors here.
        var errorCode = error.code;
        var errorMessage = error.message;
        dispatch({ type: "SIGN_ERROR", errorCode, errorMessage });
        // ...
      });
  };
};
export const microsoftSignin = () => {
  return (dispatch, getState) => {
    console.log("microsoft signin initiated");
    dispatch({ type: "MICROSOFT_LOGIN_SUCCESS" });
    // .then(() => {
    //   dispatch({ type: "LOGIN_SUCCESS" });
    // })
    // .catch((err) => {
    //   console.log(err);
    //   dispatch({ type: "LOGIN_ERROR" }, err);
    // });
  };
};
